import axios from 'axios'
import { LiquidityAssetCTO } from '@shared/LiquidityAssetCTO'

import { User } from 'oidc-client-ts'
import { logOT } from '@shared/loggingShared'
export async function fetchLiquidityAssets(serverApiBaseUrl: string, restAPIKey: string): Promise<LiquidityAssetCTO[]> {
  try {
    logOT.info('fetchLiquidityAssets', { serverApiBaseUrl, restAPIKey })
    const res = await axios.get(`${serverApiBaseUrl}/liquidityAssetAcceptance`, {
      headers: { 'x-api-key': restAPIKey },
    })
    logOT.info('fetchLiquidityAssets SUCCESS', res.data.assets)
    return res.data.assets || []
  } catch (e) {
    logOT.error('fetchLiquidityAssets error', e)
    throw e
  }
}

export async function saveLiquidityAssets(
  serverApiBaseUrl: string,
  restAPIKey: string,
  cognitoUser: User,
  assets: LiquidityAssetCTO[]
) {
  const accessToken = cognitoUser?.access_token
  await axios.put(
    `${serverApiBaseUrl}/liquidityAssetAcceptance`,
    { assets },
    { headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json', 'x-api-key': restAPIKey } }
  )
}
